import {
  Badge,
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
  Text,
  tokens,
} from "@fluentui/react-components";

import type { PipelineErrorItem } from "@/types/domain";

interface ErrorDetailsPanelProps {
  errorLog: string | null;
  pipelineErrors: PipelineErrorItem[];
}

function formatTimestamp(iso: string | null): string {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

export function ErrorDetailsPanel({
  errorLog,
  pipelineErrors,
}: ErrorDetailsPanelProps) {
  if (!errorLog && pipelineErrors.length === 0) {
    return null;
  }
  return (
    <MessageBar intent="error" style={{ marginTop: 12 }}>
      <MessageBarBody>
        <MessageBarTitle>Processing failed</MessageBarTitle>
        {errorLog ? (
          <Text
            block
            style={{
              fontFamily: "ui-monospace, monospace",
              fontSize: 12,
              whiteSpace: "pre-wrap",
              marginTop: 4,
            }}
          >
            {errorLog}
          </Text>
        ) : null}
        {pipelineErrors.length > 0 ? (
          <div
            style={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              gap: 6,
            }}
          >
            <Text size={200} weight="semibold">
              Pipeline stage errors
            </Text>
            {pipelineErrors.map((err, idx) => (
              <div
                key={idx}
                style={{
                  border: `1px solid ${tokens.colorNeutralStroke3}`,
                  borderRadius: 4,
                  padding: 6,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <Badge appearance="tint" color="danger">
                    {err.stage}
                  </Badge>
                  {err.createdAt ? (
                    <Text
                      size={100}
                      style={{ color: tokens.colorNeutralForeground2 }}
                    >
                      {formatTimestamp(err.createdAt)}
                    </Text>
                  ) : null}
                </div>
                {err.message ? (
                  <Text size={200}>{err.message}</Text>
                ) : null}
              </div>
            ))}
          </div>
        ) : null}
      </MessageBarBody>
    </MessageBar>
  );
}
